<template>
    <div class="whitespacePromo whitespacePromoB container">
        <div :class="item.customClass" class="promoSpot whitespacePromo2" style="display: block;">
            <a :href="itemHref" :data-cktag="item.description">
                <div :style="imageStyleObject" class="itemImage"></div>
                <div class="text" style="display: block;">{{item.flavorText}}</div>
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true,
        default: () => ({}),
      },
      assetHost: {
        type: String,
        required: true,
        default: () => (''),
      },
    },
    computed: {
      imageStyleObject: function () {
        if (typeof this.item !== 'undefined' && typeof this.item.image_url !== 'undefined') {
          return {
            display: 'block',
            backgroundImage: 'url(' + this.$store.state.cmsHost + this.item.image_url + ')',
          };
        } else {
          return { display: 'block' };

        }

      },
      itemHref: function(){
        let itemHref = this.item.link_url && this.item.link_url.length > 0 ? this.item.link_url : null;
        return itemHref;
      }
    },
  };
</script>
